import { render, staticRenderFns } from "./Piliangtihuan.vue?vue&type=template&id=b689cdb6&"
import script from "./Piliangtihuan.vue?vue&type=script&lang=js&"
export * from "./Piliangtihuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports